import React from 'react';
import { useEffect } from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom';


const Footer = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    if (localStorage.getItem('slang')) {
      i18n.changeLanguage(localStorage.getItem('slang'));
    } else {
      i18n.changeLanguage('zh');
      localStorage.setItem('slang', 'zh');
    }
  }, [i18n]);

  return (
    <footer className="bg-dark text-light py-1 mt-1" style={{ fontSize: '70%', width: '100%', bottom: '0' }}>
      <Container>
        <Row>
          <Col md={2}>
            <h6>{t('contactUs')}</h6>
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <ul className="list-unstyled">
              <li>{t('companyAddress')}</li>
              <li>{t('addressInfo')}</li>
            </ul>
          </Col>
          <Col md={4}>
            <ul className="list-unstyled">
              <li>{t('ft_office')}</li>
              <li>{t('office_tel')}</li>
              <li>{t('office_fax')}</li>
            </ul>
          </Col>
          <Col md={4}>
            <ul className="list-unstyled">
              <li>{t('ft_order')}</li>
              <li>{t('order_tel')}</li>
              <li>{t('order_fax')}</li>
            </ul>
          </Col>
        </Row>
        <Button size="sm" variant="link" className="text-light text-left" onClick={() => navigate('/terms-and-conditions')}>{t('terms_and_conditions')}</Button>
        <hr className="mt-2 mb-2" />
        <div className="text-center">
          <small>&copy; {new Date().getFullYear()} {t('footer')}</small>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;